export const LEVELS = [
  "Way below average",
  "Below average",
  "Average",
  "Above average",
  "Way above average",
  "Exceptional",
  "Top",
];
export const modelName = (model) => (Number(model) === 2 ? "AUS/NZ" : "Global");
export const horseName = (report) =>
  `${report.sire?.name || "Unknown sire"} × ${report.dam?.name || "Unknown dam"}`;
export const score = (report) =>
  report.main_label == null ||
  report.main_label === "" ||
  !Number.isFinite(Number(report.main_label))
    ? null
    : Number(report.main_label);
export const formatScore = (value) =>
  value == null ? "—" : Number(value).toFixed(1);
export const crossSuccessTier = (percentage) => {
  const value = Number(percentage);
  if (value > 20) return "gold";
  if (value >= 10) return "silver";
  if (value > 0) return "bronze";
  return "black";
};
export const metricDefinitions = (model) => [
  { key: "bin_spr", label: "Agility" },
  {
    key: Number(model) === 2 ? "bin_spr2" : "bin_mil",
    label: Number(model) === 2 ? "Stamina" : "General Ability",
  },
  {
    key: Number(model) === 2 ? "bin_antispr2" : "bin_sty",
    label: Number(model) === 2 ? "General Ability" : "Stamina",
  },
  { key: "bin_antispr", label: "Anti-Weakness" },
  { key: "bin_combined", label: "Combined" },
];
export const levelLabel = (value) =>
  value == null ? "Unavailable" : LEVELS[value] || "Unavailable";
export function rankedReports(reports, model, metric = "score") {
  const value = (report) =>
    metric === "score" ? score(report) : report[metric];
  return reports
    .filter(
      (report) =>
        report.status === "completed" &&
        Number(report.ml_model) === Number(model),
    )
    .sort(
      (a, b) =>
        (value(b) ?? -Infinity) - (value(a) ?? -Infinity) || a.id - b.id,
    );
}
